<template>
  <div class="row q-col-gutter-x-sm items-center">
    <div class="col">
      <slot>
        <SAIInput
          :value="value"
          :disable="disable"
          :placeholder="placeholder"
          :error="error"
          :clearable="clearable"
          :maxlength="maxlength"
          @input="$emit('input', $event)"
        />
      </slot>
    </div>
    <div>
      <SAIIconBtn
        :disable="disable"
        color="negative"
        icon="eva-trash-2-outline"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>

<script>
import { SAIInput, SAIIconBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'RemovableInputLine',
  props: {
    placeholder: String,
    value: undefined,
    disable: Boolean,
    clearable: {
      type: Boolean,
      default: true
    },
    error: Boolean,
    maxlength: Number
  },
  components: {
    SAIInput,
    SAIIconBtn
  }
};
</script>
